import { render, staticRenderFns } from "./HistorialDeTickets.vue?vue&type=template&id=b3256dee"
import script from "./HistorialDeTickets.vue?vue&type=script&lang=js"
export * from "./HistorialDeTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports